import { Cookie } from "@/services/cookie.service";
import { WindowEvent } from "@/services/windowEvents/windowEvent.service";

type CookieSetEventDetail = {
    name: Cookie;
    value: string;
};

export class CookieSetEvent extends CustomEvent<CookieSetEventDetail> {
    constructor(name: Cookie, value: string) {
        super(WindowEvent.CookieSet, {
            detail: {
                name: name,
                value: value
            }
        });
    }
}
